export default __webpack_public_path__ + "static/media/lss.a46321b6.jpg";